import "./MoreInformation.css";
import vestingFrequencyImage from "../../img/vestingFrequency.png";
export const VestingFrequency = (
  <div className="info-container flex flex-row mr-auto ml-auto">
    <div className="info-column flex flex-column ">
      <text className="sub-title">Frequency</text>
      <text className="paragraph">
        The vesting frequency is the interval at which the founder will vest a
        portion of their shares during the vesting period. The vesting frequency
        might be monthly, quarterly, every half year or annually.
      </text>
      <text className="paragraph">
        For example, if the vesting frequency is monthly, the founder would vest
        a portion of their shares each month, based on the vesting schedule.
      </text>
      <text className="sub-title mt-4">Linear vesting</text>
      <text className="paragraph">
        Linear vesting is a straightforward approach to vesting, in which the
        founder vests a consistent portion of their shares.
      </text>
      <text className="sub-title mt-4">Backloaded vesting</text>
      <text className="paragraph">
        Backloaded vesting is a vesting schedule in which a founder vests a
        smaller portion of their shares at the start of the vesting period, and
        a larger portion later on. This approach to vesting provides a slower
        start to the vesting process, and a quicker pace later on.
      </text>
      <text className="paragraph">
        The purpose of backloaded vesting is to provide an incentive for the
        founder to remain with the company for the long-term. The main
        difference with linear vesting is that the biggest portion of the shares
        are vested at the end of the scheme.
      </text>
    </div>
    <div className="info-column flex">
      <img src={vestingFrequencyImage} className="info-image mr-auto ml-auto" />
    </div>
  </div>
);
